import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const OVERLAY_STYLE = {
    maxHeight: "90vh",
    minHeight: "auto",
    scrollBehavior: "smooth",
    overflowY: "scroll",
  };

const ModalComponent = (props)=>{

    return (
        <div className="modal">
            <div className="bg-white rounded-lg drop-shadow-2xl md:w-3/5 w-4/5">
                <div className="p-4 flex items-center justify-between border-b border-solid border-gray-300">
                    <div className="uppercase font-medium">{props.header}</div>
                    <div>
                        <button onClick={props.onCloseModal} className="focus:outline-none hover:text-gray-600">
                            <FontAwesomeIcon icon={'times'} className="text-red-500 hover:text-red-700"/>
                        </button>
                    </div>
                </div>
                <div className="p-4" style={OVERLAY_STYLE}>
                    {props.children}
                </div>
            </div>
        </div>
    )

}

export default ModalComponent;